import React, { Component } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Tree,
  Space,
  Spin,
  Table,
  Switch,
} from "antd";

import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import MenuSettingStore from "../store/MenuSettingStore";

import CompanyStore from "../store/CompanyStore";

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

class MenuSettingAdd extends Component {
  formRef = React.createRef();
  constructor(prop) {
    super(prop);
    this.state = {
      loading: false,
      responseMsg: "",
      checkedKeys: [],
      modules: [],
      update: 0,
      companyId: "",
      loadList: 0,
      offset: "",
      limit: "",
      searchField: "",
      roleId: -1,
      selectedModuleIds: [],
      newObjArray: [],
      newSelectedKeysArray: [],
      loadingSpin: false,
      checkedMap: {},
    };
    this.menuSettingStore = new MenuSettingStore(this);
    this.companyStore = new CompanyStore(this);
    this.findChild = this.findChild.bind(this);
    this.rolePermission2 = JSON.parse(localStorage.getItem("rolePermission2"));
    console.log("rolePermission2", this.rolePermission2);
    this.adminCond = (Number(this.props.getUserData().isadmin) != 3 && Number(this.props.getUserData().isadmin) != -1) ? true : false
    this.columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: "40%",
        verticalAlign: "middle",
        render: (_, record) =>
          record.language
            ? this.context.translate(record.language)
            : record.name,
      },
      {
        title: "",
        width: "15%",
        render: (record) => (
          <Space>
            {record.parentId != 0 ? (
              <>
                <Switch
                  size="small"
                  disabled={
                    record.disableView == 1
                    || (this.rolePermission2?.[record.path]?.canView === 0 && this.adminCond)
                  }
                  checked={!!this.state.checkedMap[record.key]?.canView}
                  onChange={(checked) =>
                    this.handleToggle(record.key, "canView", checked, 1)
                  }
                />
                <span>View</span>
              </>
            ) : null}
          </Space>
        ),
      },
      {
        title: "",
        width: "15%",
        render: (record) => (
          <Space>
            {record.parentId != 0 ? (
              <>
                <Switch
                  size="small"
                  disabled={
                    record.disableCreate === 1
                    || (this.rolePermission2?.[record.path]?.canCreate === 0 && this.adminCond)
                  }
                  checked={!!this.state.checkedMap[record.key]?.canCreate}
                  onChange={(checked) =>
                    this.handleToggle(record.key, "canCreate", checked, 1)
                  }
                />
                <span>Create</span>
              </>
            ) : null}
          </Space>
        ),
      },
      {
        title: "",
        width: "15%",

        render: (record) => (
          <Space>
            {record.parentId != 0 ? (
              <>
                <Switch
                  disabled={
                    record.disableUpdate === 1 ||
                    (this.rolePermission2?.[record.path]?.canUpdate === 0 && this.adminCond)
                  }
                  size="small"
                  checked={!!this.state.checkedMap[record.key]?.canUpdate}
                  onChange={(checked) =>
                    this.handleToggle(record.key, "canUpdate", checked, 1)
                  }
                />
                <span>Update</span>
              </>
            ) : null}
          </Space>
        ),
      },
      {
        title: "",
        width: "15%",
        render: (record) => (
          <Space>
            {record.parentId != 0 ? (
              <>
                <Switch
                  size="small"
                  disabled={
                    record.disableDelete === 1 ||
                    (this.rolePermission2?.[record.path]?.canDelete === 0 && this.adminCond)
                  }
                  checked={!!this.state.checkedMap[record.key]?.canDelete}
                  onChange={(checked) =>
                    this.handleToggle(record.key, "canDelete", checked, 1)
                  }
                />
                <span>Delete</span>
              </>
            ) : null}
          </Space>
        ),
      },
    ];
  }
  checkParent = (data, recordKey, type, checked) => {
    // console.log(recordKey,data.parentId)
    if (data.parentId === recordKey) {
      console.log("innnn");
      this.handleToggle(data.key, type, checked, 0);
    }
    if (data.children?.length > 0) {
      data.children.forEach((data2) => {
        this.checkParent(data2, recordKey, type, checked);
      });
    }
  };

  handleToggle = (recordKey, type, checked, checkParent) => {
    //    console.log("checked", checked);
    this.setState((prevState) => {
      return {
        checkedMap: {
          ...prevState.checkedMap,
          [recordKey]: { ...prevState.checkedMap[recordKey], [type]: checked },
        },
      };
    });

    //  this.checkParent(type,recordKey)
    if (type === "canView" && checked === false) {
      this.setState((prevState) => {
        return {
          checkedMap: {
            ...prevState.checkedMap,
            [recordKey]: {
              ...prevState.checkedMap[recordKey],
              canCreate: checked,
              canUpdate: checked,
              canDelete: checked,
            },
          },
        };
      });
    }
    if (checkParent === 1) {
      this.state.modules.forEach((data) => {
        console.log(checked);
        this.checkParent(data, recordKey, type, checked);
      });
    }
  };

  onMenuSettingSubmit = async (fieldsValue) => {
    this.setState({ loading: true });
    const data = {
      ...fieldsValue,
      roleId: this.state.roleId,
      companyId: this.state.companyId,
      permission: JSON.stringify(this.state.checkedMap),
    };
    console.log("data", data);

    const response = await this.menuSettingStore.addData(data);
    await this.props.response(response);

    this.setState({ loading: false });
  };
  setSwitchValues = (data) => {
    console.log(data.path)
    if (data.path == "test module") {
      console.log("**********Permissions*****")
      console.log(data)
    }

    if (this.rolePermission2?.[data.path]?.canView === 0) { data.canView = 0; }
    if (this.rolePermission2?.[data.path]?.canCreate === 0) { data.canCreate = 0; }
    if (this.rolePermission2?.[data.path]?.canUpdate === 0) { data.canUpdate = 0; }
    if (this.rolePermission2?.[data.path]?.canDelete === 0) { data.canDelete = 0; }

    this.handleToggle(data.key, "canView", data.canView, 0);
    this.handleToggle(data.key, "canCreate", data.canCreate, 0);
    this.handleToggle(data.key, "canUpdate", data.canUpdate, 0);
    this.handleToggle(data.key, "canDelete", data.canDelete, 0);
    if (data.children?.length > 0) {
      data.children.forEach((data2) => {
        this.setSwitchValues(data2);
      });
    }
  };
  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      this.context.viewStateStore.setMenuSettingStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      console.log(this.state.companyId);
      // await this.setState({userId:this.props.getUserData().userId})
      await this.setState({ isadmin: this.props.getUserData().isadmin });
    }
    const roleId = this.props.roleId;
    const userId = this.props.getUserData().userId;
    this.setState({ loadingSpin: true });

    const modules = await this.menuSettingStore.getModules(userId, roleId);
    console.log("modules", modules);
    this.setState({
      modules: modules.modules,
      checkedKeys: modules.checkedKeys,
      loadingSpin: false,
    });
    if (roleId > 0) {
      await this.setState({ loadingSpin: true });
      const singleData = await this.companyStore.getCompanyDataById(
        modules.roleData.companyId
      );

      this.setState({ roleId: roleId, companyId: modules.roleData.companyId });

      this.formRef.current.setFieldsValue({
        rolename: modules.roleData.name,
        companyId: singleData,
      });

      console.log("innnnn");
      await this.setState({ loadingSpin: false });
    }
    modules.modules.forEach((data) => {
      this.setSwitchValues(data);
    });
  }
  async findChild(checkedKey, checked, modules) {
    //console.log(checkedKey)
    //console.log(modules)
    modules.forEach((data) => {
      if (data.key == checkedKey) {
        console.log(data.key);
        data.children.forEach((children) => {
          if (this.state.checkedKeys.includes(data.key)) {
            //add children checked
            if (!this.state.checkedKeys.includes(children.key)) {
              const newKeys = this.state.checkedKeys;
              newKeys.push(children.key);
              this.setState({ checkedKeys: newKeys });
              //console.log(this.state.checkedKeys)
              if (children.children.length > 0) {
                console.log(children.key);
                console.log(children);
                const arr = [];
                arr.push(children);
                this.findChild(children.key, checked, arr);
              }
            }
          } else {
            //remove children checked
            const newKeys2 = this.state.checkedKeys;
            const index2 = newKeys2.indexOf(children.key);
            // console.log(children.key)
            if (index2 != -1) {
              const x = newKeys2.splice(index2, 1);
              this.setState({ checkedKeys: newKeys2 });
            }
            //const x = newKeys2.splice(index2, 1);
            //this.setState({checkedKeys:newKeys})
          }
        });
      }
      if (data.children.length > 0) {
        //const children2 = [];
        //children2.push(children);
        this.findChild(checkedKey, checked, data.children);
      }
    });
    console.log(this.state.checkedKeys);
    //return moduleIds;
  }
  // async  findChild(checkedKey,checked,modules) {

  //   console.log(this.state.checkedKeys)
  //   console.log(checkedKey)
  //   modules.forEach((data) => {

  //     if(data.parentId==checkedKey){
  //      if(checked===true){
  //          if(!this.state.checkedKeys.includes(data.key)){
  //           this.setState({checkedKeys:[...this.state.checkedKeys,data.key]})
  //          }

  //      }else{
  //         const newKeys =  this.state.checkedKeys.filter(item => item !== data.key)
  //         this.setState({checkedKeys:newKeys})

  //      }
  //     }

  //     if(data.children.length>0){
  //       this.findChild(checkedKey,checked,data.children);
  //     }
  //   });
  //   console.log(this.state.checkedKeys)
  //   //return moduleIds;
  // }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    if (!this.props.params.roleId) {
      this.context.viewStateStore.setMenuSettingStates({
        companyId: this.state.companyId,
      });
    }
    await this.formRef.current.setFieldsValue({ companyId: comp.value });
    await this.handleSearch();
  }

  async handleSearch() {
    await this.menuSettingStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }
  onCheck = async (checkedKeysValue, e) => {
    await this.setState({ checkedKeys: checkedKeysValue.checked });

    let checkedKey = e.node.key;
    await this.findChild(checkedKey, e.checked, this.state.modules);
  };
  onSelect = (checkedKeysValue) => {
    //this.setState({checkedKeys:checkedKeysValue})

    console.log(checkedKeysValue);
  };

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    onSelect: (record, selected, selectedRows) => {
      console.log(record, selected, selectedRows);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log(selected, selectedRows, changeRows);
    },
  };

  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin
            spinning={this.state.loadingSpin}
            wrapperClassName="spinClass"
            fullscreen
          >
            <Form
              ref={this.formRef}
              className="formClass"
              // {...layout}
              name="nest-messages"
              layout="vertical"
              onFinish={this.onMenuSettingSubmit}
            // style={{ maxWidth: "100%", padding: 0 }}
            // validateMessages={validateMessages}
            >
              <Row className="overflowFormInputs formRowClass2">
                <Col span={12} className="formColumnClass">
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                      <Form.Item
                        name="companyId"
                        // label="Account"
                        // label={this.context.translate(
                        //   "_FLEET_DASHBORD_NEWPOI_CUSTOMER_"
                        // )}
                        // rules={[{ required: true }]}
                        label={
                          <span>
                            {this.context.translate("_ACCOUNT_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: this.context.translate("_SELECT_COMPANY_"),
                          },
                        ]}
                      >
                        <CompanyAutocomplete
                          // allowClear
                          onChange={(value) => this.handleChange(value)}
                          style={{ width: "100%" }}
                          companyId={this.state.companyId}
                        />
                      </Form.Item>
                    )}
                </Col>
                <Col span={12} className="formColumnClass">
                  <Form.Item
                    //  className="uploadCompany"
                    name="rolename"
                    // label="Role Name"
                    // label={this.context.translate(
                    //   "_FLEET_ROLE_ROLELIST_ROLENAME_"
                    // )}
                    // rules={[{ required: true }]}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_ROLE_ROLELIST_ROLENAME_"
                        )}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Table
                  columns={this.columns}
                  className="MenuSettingTable"
                  // rowSelection={Object.assign(Object.assign({}, this.rowSelection),  true )}
                  dataSource={this.state.modules}
                  showHeader={false}
                  pagination={false}
                  rowExpandedBg="red"
                  width="100%"
                  style={{ paddingBottom: "20px" }}
                />
              </Row>

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => {
                    this.closeModal();
                  }}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  htmlType="submit"
                  loading={this.state.loading}
                  className="formsSaveButton"
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}
MenuSettingAdd.contextType = StoreContext;
export default observer(withRouter(MenuSettingAdd));